import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HeaderTwo from "../parts/HeaderTwo";
import { api } from "../../../api";
import { GetPublicProfile200Response } from "../../../api/v1";
import Image from "../parts/Image";
import NoUserImage from "../../assets/images/no_user_image.webp";
import Text from "../parts/Text";
import LinkText from "../parts/LinkText";

type RankingProps = {
  backgroundColor?: string;
};

const RankingStyle = styled.div<{ $backgroundColor?: string }>`
  background: ${(props) => props.$backgroundColor || "white"};
  padding: 60px 30px 60px 30px;

  @media (max-width: 768px) {
    padding: 30px 10px 30px 10px;
  }
`;

const UserCardsStyle = styled(LinkText)`
  display: flex;
  border-top: 1px solid #dbdbdb;
  padding: 15px 5px;

  &:hover {
    background-color: #e6e6e6;
    transition: background-color 0.3s ease-in-out;
  }

  :hover {
    color: #383432;
  }
`;

const UserCardColumnLeft = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-right: 15px;
`;

const UserCardColumnCenter = styled.div`
  margin-right: 15px;
`;

const UserCardColumnRight = styled.div``;

const SmallTextStyle = styled.small`
  font-size: 16px;
`;

const Ranking: React.FC<RankingProps> = ({ backgroundColor }) => {
  const [firstUser, setFirstUser] = useState<GetPublicProfile200Response>();
  const [secondUser, setSecondUser] = useState<GetPublicProfile200Response>();
  const [thirdUser, setThirdUser] = useState<GetPublicProfile200Response>();

  useEffect(() => {
    // HACK: ユーザーのランキング情報はAPIから取得するようにする
    api.getPublicProfile("nisyuu").then((response) => {
      setFirstUser(response.data);
    });
    // api.getPublicProfile('nisyuu').then(response => {
    //   setSecondUser(response.data);
    // });
    // api.getPublicProfile('nisyuu').then(response => {
    //   setThirdUser(response.data);
    // });
  }, []);

  return (
    <RankingStyle $backgroundColor={backgroundColor}>
      <HeaderTwo mb="20px">
        ユーザーランキング<SmallTextStyle>(毎月初日更新)</SmallTextStyle>
      </HeaderTwo>
      {firstUser && (
        <UserCardsStyle href={`user/public-profile/${firstUser.username}`}>
          <UserCardColumnLeft>🥇1位</UserCardColumnLeft>
          <UserCardColumnCenter>
            <Image
              src={firstUser.imageUrl || String(NoUserImage)}
              width="72px"
              height="72px"
            />
          </UserCardColumnCenter>
          <UserCardColumnRight>
            <Text size="14px" mb="5px">
              ユーザー名：<b>{firstUser.username}</b>
            </Text>
            <Text size="14px" mb="5px">
              公開カフェノート数：<b>{firstUser.countPublicCafeNotes}</b>
            </Text>
            <Text size="14px" mb="5px">
              承認済み申請店舗数：<b>{firstUser.countApprovedRequestShops}</b>
            </Text>
          </UserCardColumnRight>
        </UserCardsStyle>
      )}
      {secondUser && (
        <UserCardsStyle href={`user/public-profile/${secondUser.username}`}>
          <UserCardColumnLeft>🥈2位</UserCardColumnLeft>
          <UserCardColumnCenter>
            <Image
              src={secondUser.imageUrl || String(NoUserImage)}
              width="72px"
              height="72px"
            />
          </UserCardColumnCenter>
          <UserCardColumnRight>
            <Text size="14px" mb="5px">
              ユーザー名：<b>{secondUser.username}</b>
            </Text>
            <Text size="14px" mb="5px">
              公開カフェノート数：<b>{secondUser.countPublicCafeNotes}</b>
            </Text>
            <Text size="14px" mb="5px">
              承認済み申請店舗数：<b>{secondUser.countApprovedRequestShops}</b>
            </Text>
          </UserCardColumnRight>
        </UserCardsStyle>
      )}
      {thirdUser && (
        <UserCardsStyle href={`user/public-profile/${thirdUser.username}`}>
          <UserCardColumnLeft>🥉3位</UserCardColumnLeft>
          <UserCardColumnCenter>
            <Image
              src={thirdUser.imageUrl || String(NoUserImage)}
              width="72px"
              height="72px"
            />
          </UserCardColumnCenter>
          <UserCardColumnRight>
            <Text size="14px" mb="5px">
              ユーザー名：<b>{thirdUser.username}</b>
            </Text>
            <Text size="14px" mb="5px">
              公開カフェノート数：<b>{thirdUser.countPublicCafeNotes}</b>
            </Text>
            <Text size="14px" mb="5px">
              承認済み申請店舗数：<b>{thirdUser.countApprovedRequestShops}</b>
            </Text>
          </UserCardColumnRight>
        </UserCardsStyle>
      )}
    </RankingStyle>
  );
};

export default Ranking;
